import React from "react";
import PropTypes from "prop-types";
import Menu from "@material-ui/core/Menu";

import "./style.scss";

function PlacebarDropdown({anchorEl, onClose, className, menuItems, header, navigation}) {
  return (
    <Menu
      className={`menuDropdown placebarMenu ${className}`}
      open
      anchorEl={anchorEl}
      transformOrigin={{horizontal: "left", vertical: "bottom"}}
      onClose={onClose}>
      {navigation}
      {header}
      {menuItems}
    </Menu>
  );
}

PlacebarDropdown.propTypes = {
  anchorEl: PropTypes.instanceOf(HTMLElement),
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  menuItems: PropTypes.node,
  header: PropTypes.node,
  navigation: PropTypes.node
};

export default PlacebarDropdown;



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/PlacebarDropdown/index.jsx